import { Component, OnInit, OnDestroy, ViewChild, ChangeDetectorRef } from '@angular/core';
import { NavParams, IonSlides, ModalController, Platform } from '@ionic/angular';
import { State } from 'src/app/Models/Classes/Publications/Story/State/state';
import { StoryPublication } from 'src/app/Models/Classes/Publications/Story/story-publication';
import { Utils } from 'src/app/Models/Classes/utils';
import { Profile } from './../../../Models/Classes/User/profile';
import { Capacitor } from '@capacitor/core';
import { FormServiceService } from 'src/app/services/publications/form-service.service';
import { PublicationService } from 'src/app/services/publications/publication.service';


@Component({
	selector: 'app-story-viewer',
	templateUrl: './story-viewer.component.html',
	styleUrls: ['./story-viewer.component.scss'],
})
export class StoryViewerComponent implements OnInit, OnDestroy {
	interval;
	public typeTextCalled:boolean=false;
	public titleTyping:any;
	@ViewChild('slides', { static: true }) slides: IonSlides;
	slideOpts: any = {
		grabCursor: true,
		cubeEffect: {
			shadow: true,
			slideShadows: true,
			shadowOffset: 20,
			shadowScale: 0.94,
		}
	};
	private clickHandler: any;
	private progressFrame: number | null = null;
	private lastProgressTimestamp = 0;
	public currentProgress = 0;
	public currentTimeSeconds = 0;
	public currentDurationSeconds = 0;
	private readonly onVisibilityChange = () => {
		this.lastProgressTimestamp = performance.now();
	};
	private timeClick: number = 0;
	private videoCurrentTime: number = 0;

	private video: HTMLMediaElement;


	public isShowing: boolean = false;
	private isPaused: boolean;

	public stories: Array<StoryPublication>;
	public timeSincePublish: string = "Justo ahora";

	public currentStoryIndex: number = 0;
	public currentStateIndex: number = 0;
	authorList$: any;

	constructor(
		public navParams: NavParams,
		private modalCtrl: ModalController,
		public platform: Platform,
		private cdRef: ChangeDetectorRef,
		private utils: Utils,
		private publicationService: PublicationService,
		private formService: FormServiceService,
	) {
		this.isPaused = true; // Empieza con el progressbar en pausa
		this.stories = this.navParams.get('stories'); // obtiene las historias
		console.log("states,Received Stories: ", this.stories);
		this.slideOpts.initialSlide = this.navParams.get('tapped'); //obtiene el indice de historia abierta
		this.currentStoryIndex = this.slideOpts.initialSlide; // inicializa la historia actual
	}

	ngOnInit() {
		document.addEventListener('visibilitychange', this.onVisibilityChange);
		this.slides.update().then(() => {
			this.stateFinish().then(() => {
				this.isShowing = true;
				this.stateStart().then((data) => {
				}).catch((error) => {
					console.error(error);
				});
			}).catch((error) => {
				console.error(error);
			});
		}).catch((error) => {
			console.error(error);
		});
	}
	public Replace(url: string) {
		return typeof url === 'string' ? url.split('?')[0] : '';
  }
  typeText(text: string, delay: number, currentStateIndex) {
	 // Check if typeText has already been called for this currentStateIndex
	 if (this.typeTextCalled) {
		return;
	  }
	
	  this.typeTextCalled = true; // Set the flag to indicate 
	let index = 0;
	clearInterval(this.interval);
	 this.interval = setInterval(() => {
	  if (index < text.length) {
		this.titleTyping = text.slice(0, index + 1);
		index++;
	  } else {
		clearInterval(this.interval);
	  }
	}, delay);
  }
  
  
  
	public startInterval(event: any) { //Inicia el contador de boton presionado
		this.clickHandler = setInterval(() => {
			this.timeClick++;
			if (this.timeClick > 30) {
				//pausa el estado
				this.statePause();
			}
		}, 10);
	}

	public stopInterval(event: any) { // finaliza el contador del boton presionado
		clearInterval(this.clickHandler);
		if (this.timeClick < 30) { // si el boton duro menos de 30 milisegundos presionado cambia de estado
			this.timeClick = 0;
			this.selectChangeItem(event);
		} else { // si duró mas simplemente reinicia el boton y reanuda el progress bar
			this.timeClick = 0;
			this.stateReanude();
			// reanuda el progress bar
		}
	}

	public selectChangeItem(event: any) { // Obtiene una posicion en el cursor y selecciona a cual item cambiarse

		if (event.offsetX < event.path[0].clientWidth / 2) {
			this.changeItem(-1);
		} else {
			this.changeItem(+1);

		}
	}
	

	public changeItem(direction: number) { // Cambia de estado
		this.isShowing = false;
		let tempStateIndex = this.currentStateIndex + direction;
		if (tempStateIndex >= 0 && tempStateIndex <= this.getActualStory().states.length - 1) { // Verifica que puedas cambiar de estado
			this.updateItem(direction).then(() => {
				this.stateStart().then(() => {

				}).catch((error) => {
					console.error(error);
				});
			}).catch((error) => {
				console.error(error);
			});
		} else { // Hay que realizar un cambio de historia
			let tempStoryIndex = this.currentStoryIndex + direction;
			if (tempStoryIndex < 0 || tempStoryIndex > this.stories.length - 1) {
				this.closeModal();
			} else {
				this.updateSlide(direction).then(() => {
					this.stateStart().then(() => {
					}).catch((error) => {
						console.error(error);
					});
				}).catch((error) => {
					console.error(error);
				});
			}
		}
	}

	public updateItem(direction: number): Promise<boolean> {
		return new Promise((resolve, reject) => {
			this.stateFinish().then(() => {
				this.currentStateIndex += direction;
				resolve(true);
			}).catch((error) => {
				reject(error);
			});
		});
	}

	public updateSlide(direction: number): Promise<any> {
		return new Promise((resolve, reject) => {
			this.stateFinish().then(() => {
				this.currentStoryIndex += direction;
				this.currentStateIndex = 0;
				if (direction > 0) {
					this.slides.slideNext().then((slide) => { //Cambia de historia
						resolve(slide);
					}).catch((error) => {
						reject(error);
					});
				} else {
					this.currentStateIndex = 0;
					this.slides.slidePrev().then((slide) => { // Cambia de historia
						resolve(slide);
					}).catch((error) => {
						reject(error);
					});
				}
			}).catch((error) => {
				reject(error);
			});
		});
	}

	private stateStart(): Promise<any> {
		return new Promise((resolve, reject) => {
			const actualStory = this.getActualStory();
			this.publicationService.markStoryAsSeen(actualStory, this.formService.profile);
			this.utils.calcularTiempo(actualStory.createdAt).then(time => {
				this.timeSincePublish = time;
				this.isShowing = true;
				if (this.getActualState().media.typeData == 'Video') {
					this.findVideo(this.getActualState().media.id.toString()).then((video) => {
						this.playVideo().then(() => {
							this.stateInit(video.duration, 'video');
							resolve(true);
						}).catch((error) => {
							reject(error);
						});
					}).catch((error) => {
						reject(error);
					});
				} else {
					this.stateInit(10000, 'imagen');
					resolve(true);
				}
			}).catch((error) => {
				reject(error);
			});
		});
	}

	public stateInit(duration: number, type: string) {
		this.stopProgress();
		this.currentProgress = 0;
		this.currentTimeSeconds = 0;
		this.currentDurationSeconds = type === 'video'
			? (Number.isFinite(this.video?.duration) && this.video.duration > 0 ? this.video.duration : 0)
			: duration / 1000;
		this.isPaused = false;
		this.lastProgressTimestamp = performance.now();
		let elapsed = 0;
		const tick = (timestamp: number) => {
			const delta = timestamp - this.lastProgressTimestamp;
			this.lastProgressTimestamp = timestamp;
			if (!this.isPaused && !document.hidden) {
				if (type === 'video') {
					const video = this.video;
					if (video && Number.isFinite(video.duration) && video.duration > 0) {
						this.currentDurationSeconds = video.duration;
						this.currentTimeSeconds = Math.min(video.duration, Math.max(0, video.currentTime));
						this.currentProgress = Math.min(1, Math.max(0, video.currentTime / video.duration));
					}
					if (video?.ended) {
						this.progressFrame = null;
						this.changeItem(1);
						return;
					}
				} else {
					elapsed += delta;
					this.currentTimeSeconds = Math.min(elapsed, duration) / 1000;
					this.currentProgress = Math.min(1, elapsed / duration);
					if (this.currentProgress >= 1) {
						this.progressFrame = null;
						this.changeItem(1);
						return;
					}
				}
			}
			this.progressFrame = requestAnimationFrame(tick);
		};
		this.progressFrame = requestAnimationFrame(tick);
	}

	private stopProgress() {
		if (this.progressFrame !== null) cancelAnimationFrame(this.progressFrame);
		this.progressFrame = null;
	}

	private statePause() {
		if (this.getActualState().media.typeData == 'Video') {
			if (this.video != undefined) {
				this.pauseVideo().then(() => {
					this.isPaused = true;
				});
			}
		} else {
			this.isPaused = true;
		}
	}

	private stateReanude() {
		if (this.getActualState().media.typeData == 'Video') {
			if (this.video != undefined) {
				this.playVideo().then(() => {
					this.isPaused = false;
				});
			}
		} else {
			this.isPaused = false;
		}
	}

	public stateFinish(): Promise<any> { // Detiene  la barra de progreso
		return new Promise((resolve, reject) => {
			this.stopProgress();
			this.currentProgress = 0;
			this.currentTimeSeconds = 0;
			this.currentDurationSeconds = 0;
			this.typeTextCalled=false;

			if (this.getActualState().media.typeData == 'Video') {

				if (this.video != undefined) {
					this.pauseVideo().then(() => {

						this.isPaused = true;
						resolve(true);
					}).catch((error) => {
						reject(error);
					});
				} else {
					resolve(true);
				}
			} else {

				this.isPaused = true;
				resolve(true);
			}
		});
	}

	private findVideo(id: string): Promise<any> {
		return new Promise((resolve, reject) => {
			this.cdRef.detectChanges();
			this.video = <HTMLMediaElement>document.getElementById(id);
			if (this.video != undefined) {
				resolve(this.video);
			} else {
				reject(undefined);
			}
		});
	}

	public playVideo(): Promise<any> {
		return new Promise((resolve, reject) => {
			this.video.play().then((video) => {
				resolve(video);
			}).catch((error) => {
				reject(error);
			});
		});
	}

	public pauseVideo(): Promise<any> {
		return new Promise((resolve, reject) => {
			try {

				this.video.pause();

				resolve(true);
			} catch (e) {
				reject(e);
			}
		});
	}

	public closeModal() {
		clearInterval(this.clickHandler);
		clearInterval(this.interval);
		this.stopProgress();
		this.video?.pause();
		this.modalCtrl.dismiss();
	}

	ngOnDestroy() {
		this.stopProgress();
		clearInterval(this.clickHandler);
		clearInterval(this.interval);
		this.video?.pause();
		document.removeEventListener('visibilitychange', this.onVisibilityChange);
	}

	private getActualState(): State {
		return this.stories[this.currentStoryIndex].states[this.currentStateIndex];
	}

	private getActualStory(): StoryPublication {
		return this.stories[this.currentStoryIndex];
	}

	public getStateProgress(storyIndex: number, stateIndex: number): number {
		if (storyIndex !== this.currentStoryIndex) return storyIndex < this.currentStoryIndex ? 1 : 0;
		if (stateIndex < this.currentStateIndex) return 1;
		if (stateIndex > this.currentStateIndex) return 0;
		return this.currentProgress;
	}

	public formatStoryTime(seconds: number): string {
		const wholeSeconds = Math.max(0, Math.floor(seconds));
		return `${Math.floor(wholeSeconds / 60)}:${String(wholeSeconds % 60).padStart(2, '0')}`;
	}

	public slideChanged() {
		this.slides.getActiveIndex().then((index) => {
			this.stateFinish().then(() => {
				this.currentStoryIndex = index;
				this.currentStateIndex = 0;
				this.stateStart().then(() => {
				}).catch((error) => {
					console.error(error);
				});
			});
		}).catch((error) => {
			console.error(error);
		});
	}
	public getStoryUsername(story: any): string {
		const profile = story?.userProfile || story?.user_profile || story?.author || story?.user || {};
		const username = profile?.username
			|| profile?.userName
			|| story?.username
			|| story?.userName
			|| story?.author?.username
			|| story?.user?.username;

		return typeof username === 'string' && username.trim() ? username.trim() : 'Usuario';
	}

	public getAbsoluteImageUrl(relativeUrl: any): string {
		const baseUrl = 'https://laniakea-multimedia.s3.amazonaws.com/';
		let source = relativeUrl;

		for (let depth = 0; depth < 3 && source && typeof source === 'object'; depth++) {
			const nestedPhoto = source.url
				|| source.route
				|| source.path
				|| source.src
				|| source.localUrl
				|| source.photo_url
				|| source.photoUrl
				|| source.profile_photo
				|| source.profilePhoto;
			if (nestedPhoto === source) {
				break;
			}
			source = nestedPhoto;
		}

		const value = typeof source === 'string' ? source.trim() : '';
		if (!value || value === 'null' || value === 'undefined') {
			return 'assets/icon/usuario.png';
		}

		if (/^(https?:|blob:|data:|capacitor:|file:)/i.test(value) || value.startsWith('assets/') || value.startsWith('/assets/')) {
			return value;
		}

		return baseUrl + value.replace(/^\/+/, '');
	}
}
